import * as Styled from 'components/PageWrappers/AdDetails/components/PostEnquirySimilarAdsModal/PostEnquirySimilarAdsModal.styled';

import { SimilarAdCard } from 'components/PageWrappers/AdDetails/components/PostEnquirySimilarAdsModal/components/SimilarAdCard/SimilarAdCard';

import type { PostEnquirySimilarAdsModalProps } from 'components/PageWrappers/AdDetails/components/PostEnquirySimilarAdsModal/PostEnquirySimilarAdsModal.typed';

import { CDN_STATIC_ASSETS } from '../../../../../utils';
import type { ISearchPageAds } from 'api/types/searchPageApiTypes';

function PostEnquirySimilarAdsModal(props: PostEnquirySimilarAdsModalProps) {
  const { isOpen, askToClose, vendorName, domain, similarAds } = props;

  return (
    <Styled.SBaseModal
      isOpen={isOpen}
      askToClose={askToClose}
      testId="post-message-modal"
    >
      <div>
        <Styled.Header>
          <Styled.IconContainer>
            <img
              src={`${CDN_STATIC_ASSETS}/images/illustrations/chat.svg`}
              alt="Chat image"
              width="40"
              height="40"
            />
          </Styled.IconContainer>
          <Styled.Title>Message Sent</Styled.Title>
        </Styled.Header>
        <Styled.SubText>
          You will be notified instantly when {vendorName} replies to your
          message.
        </Styled.SubText>
      </div>
      {similarAds && similarAds.length > 0 && (
        <Styled.SimilarAdsContent>
          <Styled.SimilarAdsBlurb>You may also like...</Styled.SimilarAdsBlurb>
          <Styled.SimilarAdsGrid>
            {similarAds.map((similarAd: ISearchPageAds, index: number) => (
              <SimilarAdCard
                key={similarAd.id}
                domain={domain}
                updateCampaignNumber={17}
                hide={index > 3}
                {...similarAd}
              />
            ))}
          </Styled.SimilarAdsGrid>
        </Styled.SimilarAdsContent>
      )}
    </Styled.SBaseModal>
  );
}

export { PostEnquirySimilarAdsModal };
